import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { RESULT_META } from "@/components/ResultBadge";

/**
 * BalanceBar — a small labelled 0–100 progress bar for Daily balance.
 * Color follows the result (falls back to the gold "stay" tint).
 */
export function BalanceBar({ value, result = "stay", testId }) {
  const meta = RESULT_META[result] || RESULT_META.stay;
  const color = meta.color;
  const clamped = Math.max(0, Math.min(100, Number(value) || 0));
  const { t } = useI18n();

  return (
    <div className="w-full" data-testid={testId}>
      <div className="flex items-center justify-between mb-2">
        <p className="text-[11px] uppercase tracking-[0.16em] text-[#E8D8B8]/80">
          {t("result.balanceLabel")}
        </p>
        <span
          className="text-lg font-medium tabular-nums"
          style={{ color, letterSpacing: "-0.01em" }}
          data-testid={testId ? `${testId}-value` : undefined}
        >
          {clamped}
          <span className="text-xs text-white/40 ml-1">/100</span>
        </span>
      </div>
      <div
        className="h-2 rounded-full overflow-hidden"
        style={{ background: "rgba(255,255,255,0.06)" }}
      >
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{
            width: `${clamped}%`,
            background: `linear-gradient(90deg, ${color}66, ${color})`,
          }}
        />
      </div>
    </div>
  );
}
